<template>
  <div class="mt-3">
    <v-row dense>
      <v-col cols="12">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          init-search
          type="TIPO_COMPRA"
          label="Tipo de compra"
          class="required rounded-tag-small"
          v-model="formData.tipoCompra"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
